import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, GitBranch } from 'lucide-react';
import { DependencyVisualization } from '../components/Dependencies/DependencyVisualization';

const Dependencies: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              <Link to="/" className="flex items-center gap-2 text-gray-500 hover:text-gray-700">
                <ArrowLeft className="w-4 h-4" />
                Back to Dashboard!
              </Link>
              <div className="border-l border-gray-300 h-6" />
              <div className="flex items-center gap-3">
                <GitBranch className="w-6 h-6 text-blue-600" />
                <h1 className="text-xl font-semibold text-gray-900">Cross-Project Dependencies</h1>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 sm:px-6 lg:px-8 py-8">
        <DependencyVisualization />
      </main>
    </div>
  );
};

export default Dependencies;
